/* import __COLOCATED_TEMPLATE__ from './sq-field-input-percent.hbs.js'; */
// `SqFieldInputPercentComponent` is a variation on the `SqInputPercentComponent`, a text field input
// with localized formatting for a percentages. Like, other `SqFieldInput` components, the input is technically
// standalone, but is really intended to be nested inside a Form Field block component. The two components
// communicate with each other over event handling and auto fill in placeholder if you don't add one.
//
// MinimumFractionDigitBindings controls how many digits your percentage will show. (e.g. 12.34% vs 12.3%)
// Other parameters to the component can follow any standard Ember Input helper. Not really anything proprietary or new here.
//
// Sass dependencies at:
// `app/assets/stylesheets/bridgeport/components/form-elements/formfield/_formfield.sass`
// ## Example
//
// {{sq-field-input-percent value=model.percentage
//                          maximumFractionDigits=fractionDigits
//                          placeholder=(t-i18n "products.settings.taxes.amount")}}

/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */
import FieldElementSupport from '@square/glass-ui/utils/field-element-support';
import SqInputPercentComponent from '@dashboard/shared-ui/components/sq-input-percent';
export default class SqFieldInputPercent extends SqInputPercentComponent.extend(FieldElementSupport) {}